import { service } from "../utils/request";

//评论列表
export function CommentList(data) {
  return service({
    url: "shop/agent.comment/index",
    method: "post",
    data: data
  });
}

//添加虚拟评论
export function AddComment(data) {
  return service({
    url: "shop/agent.comment/addComment",
    method: "post",
    data: data
  });
}

//修改评论
export function EditComment(data) {
  return service({
    url: "shop/agent.comment/editComment",
    method: "post",
    data: data
  });
}

//删除评论
export function DelComment(data) {
  return service({
    url: "shop/agent.comment/deleteComment",
    method: "post",
    data: data
  });
}

export function addImage(data) {
  //上传图片
  return service({
    url: "api/Upload/uploads",
    method: "post",
    data: data
  });
}